import type { MentionType } from '@aline/common';
import { getIsMentionType } from '@aline/common';

const MENTION_PREFIX = 'mention:';
const ALINE_AI_MENTION = 'mention:aline-ai';
const DOCUMENT_MENTION_PREFIX = 'mention:document/';

type ParsedIdMentionUrl = {
  id: string;
  type: MentionType;
};

export type ParsedMentionUrl = ParsedIdMentionUrl | { type: 'aline-ai' };

export function getDocumentIdFromMentionUrl(href: string): string | null {
  if (!href.startsWith(DOCUMENT_MENTION_PREFIX)) return null;
  // Strip any `?query` suffix before reading the id, like parseMentionUrl.
  return href.slice(DOCUMENT_MENTION_PREFIX.length).split('?')[0] || null;
}

export function parseMentionUrl(href: string): ParsedMentionUrl | null {
  if (href === ALINE_AI_MENTION) return { type: 'aline-ai' };
  if (!href.startsWith(MENTION_PREFIX)) return null;

  const path = href.slice(MENTION_PREFIX.length).split('?')[0];
  const slashIndex = path.indexOf('/');
  if (slashIndex === -1) return null;

  const type = path.slice(0, slashIndex);
  const id = path.slice(slashIndex + 1);
  if (!id || !getIsMentionType(type)) return null;

  return { id, type };
}

export function getMentionDisplayText(text: string) {
  const trimmedText = text.trim();
  return trimmedText.startsWith('@') ? trimmedText.slice(1) : trimmedText;
}
